import { useMemo, useState, type ReactNode } from 'react';
import { AboutSheet } from './AboutSheet';
import { Header } from './Header';
import { HowToPlaySheet } from './HowToPlaySheet';
import { MenuSheet } from './MenuSheet';
import { StatsSheet } from './StatsSheet';
import { navigate } from '../lib/router';
import { ShellProvider } from '../state/ShellContext';
import { useApp } from '../state/AppContext';

type SheetName = 'menu' | 'stats' | 'how-to' | 'about' | null;

export function Shell({ children }: { children: ReactNode }) {
  const { profile, stats } = useApp();
  const [sheet, setSheet] = useState<SheetName>(null);
  const api = useMemo(
    () => ({ openMenu: () => setSheet('menu'), openStats: () => setSheet('stats') }),
    [],
  );
  const close = () => setSheet(null);
  const go = (path: string) => {
    setSheet(null);
    navigate(path);
  };

  return (
    <ShellProvider value={api}>
      <Header onMenu={api.openMenu} onStats={api.openStats} />
      <main className="flex w-full min-h-0 flex-1 flex-col gap-1 sm:gap-3">{children}</main>
      <MenuSheet
        open={sheet === 'menu'}
        onClose={close}
        onTodaysPuzzle={() => go('/')}
        onJourney={() => go('/journey')}
        onNewChallenge={() => go('/challenge/new')}
        onMyChallenges={() => go('/challenges')}
        onHowToPlay={() => setSheet('how-to')}
        onAbout={() => setSheet('about')}
      />
      <StatsSheet open={sheet === 'stats'} onClose={close} stats={stats} profile={profile} />
      <HowToPlaySheet open={sheet === 'how-to'} onClose={close} />
      <AboutSheet open={sheet === 'about'} onClose={close} />
    </ShellProvider>
  );
}
